export default [
    'lamp',
    'goldenLamp',
    'puddle',
    'bucket',
    'skeleton',
    'bones',
    'bones1',
    'bones2',
    'bones3',
    'bloodBones',
    'enemy',
    'enemyXWalking',
    'enemyYWalking',
    'enemyUp',
    'enemyDown',
    'enemyLeft',
    'enemyRight',
    'dogFood',
    'food',
    'health',
    'ammo',
    'powerUp',
    'machinegun',
    'chaingun',
]